import { Component } from '@angular/core';

@Component({
    selector: 'ibex-snackbar',
    templateUrl: './ibex-snackbar.component.html',
    styleUrls: ['./ibex-snackbar.component.scss'],
    standalone: false
})

export class IbexSnackbarComponent {
  message = '';
  action = '';
  visible = false;
  style = null;

  timeout;

  show(message: string, duration: number = 3000, style = null) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.style = style;
    this.message = message;
    this.visible = true;

    this.timeout = setTimeout(() => {
      this.visible = false;
    }, duration);
  }

  close() {
    this.visible = false;
    clearTimeout(this.timeout);
  }
}
